// extracted by mini-css-extract-plugin
export default {"introductionHolder":"Introduction_introductionHolder__wwZKC","introduction":"Introduction_introduction__tlvmD"};